<template>
  <div class="navbar-link" ref="nLink">
    <div class="navbar-link__margin"></div>
    <div class="navbar-link__wrapper">
      <div class="navbar-link__links">
        <router-link
          class="navbar-link__links-item"
          v-for="(item, index) in enabledMenu"
          :key="index"
          :to="item.path"
        >
          <fai class="navbar-link__links-item-icon" :icon="item.icon"></fai>
          <span class="navbar-link__links-item-text">{{ $t('view.'+item.text+'.linkTitle') }}</span>
        </router-link>
        <div v-show="pluginsViews.length" class="navbar-link__divider"></div>
        <router-link
          class="navbar-link__links-item"
          v-for="item in pluginsViews"
          :key="item.name"
          :to="item.path"
        >
          <fai class="navbar-link__links-item-icon" :icon="item.meta.icon"></fai>
          <div
            class="navbar-link__links-item-text"
          >{{ $t(`plugins.${item.meta.pluginPrefix}.${item.meta.localeKey}`) }}</div>
        </router-link>
      </div>
      <div
        class="navbar-link__version"
      >{{ `${$t('common.version')}: ${this.$store.state.version}` }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../store'

export default {
  data() {
    return {
      len: 0
    }
  },
  props: {
    menu: Array,
    value: Number
  },
  mounted() {
    this.getWidth()
    this.$nextTick(() => {
      this.getWidth()
    })
  },
  computed: {
    enabledMenu: function () {
      let permittedTo = this.$store.state.user.permissions.filter(item => { if (item.permitted) return true })
      permittedTo = permittedTo.map(item => { return item.path.slice(4) })
      return this.menu.filter(item => {
        if (item.path === '/' || item.path === '/settings') return true
        for (let i = 0; i < permittedTo.length; i++) {
          if (item.path === permittedTo[i]) return true
        }
        return false
      })
    },

    locale: function () {
      return this.$i18n.locale
    },

    pluginsViews: function () {
      return this.$router.options.routes.filter(r => r.meta && r.meta.plugin && r.meta.showInNavbar)
    }
  },
  watch: {
    $route: function () {
      this.getWidth()
    },
    locale: function () {
      this.getWidth()
    }
  },
  methods: {
    getWidth() {
      setTimeout(() => {
        this.len = JSON.parse(JSON.stringify(this.$refs.nLink.clientWidth))
        this.$emit('input', JSON.parse(JSON.stringify(this.len)))
      }, 0)
    }
  }
}
</script>

<style lang="scss">
.navbar-link {
  @include boxShadow(-2px, 0px, 15px, -12px, rgba(0, 0, 0, 0.75));
  padding: 0 8px 0 8px;
  margin: 0px 0 10px 0;
  transition: margin-right 1s, transform 1s;
  z-index: 1000;
  background-color: white;
  overflow-y: auto;
  min-width: 106px;

  &::-webkit-scrollbar-track {
    background: white;
  }

  &::-webkit-scrollbar-thumb {
    background: white;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 1;
  }

  &__margin {
    position: fixed;
    min-width: 106px;
    height: 8px;
    background: white;
  }

  &__filler {
    flex-grow: 1;
  }

  &__links{
    margin-top: 8px;
  }

  &__links-item {
    text-decoration: none;
    padding: 8px;
    color: #2c3e50;
    border-radius: 10px;
    margin-bottom: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90px;
    overflow: hidden;
  }

  &__links .router-link-exact-active[href="/"] {
    color: white;
    background-color: $primary;
  }

  &__links .router-link-active:not([href="/"]) {
    color: white;
    background-color: $primary;
  }

  &__links-item-icon {
    font-size: 1.33em;
    margin-bottom: 5px;
  }

  &__links-item-text {
    text-transform: uppercase;
    text-align: center;
    font-size: 0.8em;
    width: 100%;
  }

  &__toggle {
    font-size: 3em;
    padding: 10px;
    cursor: pointer;
  }

  &__divider {
    width: 60%;
    height: 1px;
    margin: 10px auto;
    background-color: $borderGrey;
  }

  &__version {
    min-width: 106px;
    text-align: center;
    position: absolute;
    font-size: 0.8em;
    bottom: 0;
    padding: 10px 0 10px 0;
    font-weight: 700;
    background: white;
  }
}
</style>